import type { KalamaTeaserSurface } from '@shared/core/analytics'
import { useCallback } from 'react'
import { useMutation } from 'react-query'
import { ApiService } from 'src/services/api.service'

export const RECORD_KALAMA_TEASER_SEEN_MUTATION_KEY = 'record-kalama-teaser-seen'

export type RecordKalamaTeaserSeenOptions = {
  onSuccess?: () => void
}

export type RecordKalamaTeaserSeen = (surface: KalamaTeaserSurface, options?: RecordKalamaTeaserSeenOptions) => void

export function useRecordKalamaTeaserSeen(): RecordKalamaTeaserSeen {
  const { mutate } = useMutation(RECORD_KALAMA_TEASER_SEEN_MUTATION_KEY, (surface: KalamaTeaserSurface) =>
    ApiService.Analytics.recordKalamaTeaserSeen(surface),
  )

  // `mutate` swallows request errors, so a failed record never throws into the banner.
  return useCallback<RecordKalamaTeaserSeen>(
    (surface, options) => mutate(surface, { onSuccess: options?.onSuccess }),
    [mutate],
  )
}
